export default "__VITE_ASSET__DJwtcXz3__"